export default __webpack_public_path__ + "static/media/banner6.9d403f77.png";